import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Router } from '@angular/router';

import { EMPTY, Observable, catchError, throwError } from 'rxjs';

// Environments
import { environment } from '@env';

export const MaintenanceHttpInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!isBackendUnavailable(req, error)) {
        return throwError(() => error);
      }

      // The browser URL is kept so a reload retries the page the user was on. Re-navigating to the same route is ignored by the router.
      void router.navigateByUrl('/maintenance', { skipLocationChange: true });

      // Completing silently keeps the global error toast out of the maintenance flow.
      return EMPTY;
    }),
  );
};

const isBackendUnavailable = (req: HttpRequest<unknown>, error: unknown): boolean =>
  error instanceof HttpErrorResponse &&
  error.status === HttpStatusCode.ServiceUnavailable &&
  req.url.startsWith(environment.backend.url);
